module.exports = __webpack_public_path__ + "static/fonts/DINMittelschriftStd.d00cc20.ttf";